// A video player with simplistic custom controls
// * Play/Pause toggle button

import h from 'hyperscript';
import generateIcon from 'components/_particles/icon/icon';

export default class CustomPlayer {
  constructor($video, options = {}) {
    this.$el = $video;

    this.options = {
      playerClassname: 'video__player',
      playerControlsClassname: 'video__custom-player-controls',
      playButtonText: this.$el.dataset.labelPlay,
      playButtonIcon: 'play',
      pauseButtonText: this.$el.dataset.labelPause,
      pauseButtonIcon: 'pause-mini',
      ...options,
    };

    this.$player = this.$el.querySelector(`.${this.options.playerClassname}`);

    this.init();
  }

  init() {
    this.$player.removeAttribute('controls');

    // Set up controls
    this.createCustomPlayer();
  }

  createCustomPlayer() {
    const $controlsContainer = h(`.${this.options.playerControlsClassname}`);

    this.$playPauseButton = h('button.button.button--secondary.button--no-focus', {
      type: 'button',
    }, [generateIcon({
      icon: 'play',
      classes: ['button__icon'],
    })], h('span.button__text', this.options.playButtonText));

    this.bindedPlayPause = this.playPauseMedia.bind(this);
    this.$playPauseButton.addEventListener('click', this.bindedPlayPause);

    $controlsContainer.append(this.$playPauseButton);
    this.$el.append($controlsContainer);
  }

  playPauseMedia() {
    // console.log(this.$playPauseButton.querySelector('.button__icon'));
    if (this.$player.paused) {
      const $pauseIcon = h('span', [generateIcon({
        icon: this.options.pauseButtonIcon,
        classes: ['button__icon'],
      })]);

      const $icon = this.$playPauseButton.querySelector('.button__icon');
      const $iconParent = $icon.parentNode;
      $iconParent.replaceChild($pauseIcon.querySelector('.button__icon'), $icon);
      this.$playPauseButton.querySelector('.button__text').innerHTML = this.options.pauseButtonText;
      this.$player.play();
    } else {
      const $playIcon = h('span', [generateIcon({
        icon: this.options.playButtonIcon,
        classes: ['button__icon'],
      })]);

      const $icon = this.$playPauseButton.querySelector('.button__icon');
      const $iconParent = $icon.parentNode;
      $iconParent.replaceChild($playIcon.querySelector('.button__icon'), $icon);

      this.$playPauseButton.querySelector('.button__text').innerHTML = this.options.playButtonText;
      this.$player.pause();
    }
  }
}
